import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './components/dashboard/dashboard';
import NewCustomer from './components/new-customer/new-customer';
import Deposit from './components/deposit/deposit';
import Withdraw from './components/withdraw/withdraw';
import Transfer from './components/transfer/transfer';
import Balance from './components/balance/balance';
import './App.css';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/new" element={<NewCustomer />} />
        <Route path="/deposit" element={<Deposit />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="/transfer" element={<Transfer />} />
        <Route path="/balance" element={<Balance />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
